import { each, flatMap, go, sel } from 'fxjs/es';
import axios from 'axios';
import { changeDpiBlob } from 'changedpi';
import { SVGEditorUtilF } from './module/SVGEditorUtilF.js';

async function verifyKeyringHook(svg_product_page) {
  if (svg_product_page.is_legacy_no_hole === true) {
    const {
      is_OK,
      data: image_url,
      reason,
    } = await SVGEditorUtilF.verifySmallHoleSvg({
      svg_product_page_id: svg_product_page.id,
      printable_url: svg_product_page.printable_url,
      cutting_line_url: svg_product_page.cutting_line_url,
    });
    if (!is_OK) {
      throw new Error(`${svg_product_page.id} --- ${reason}`);
    }
    if (is_OK && image_url) {
      svg_product_page.printable_url = image_url;
    }
  } else if (svg_product_page.is_legacy_no_hole === false) {
    if (!svg_product_page.verified_printable_url)
      throw new Error(`${svg_product_page.id} --- svg_product_page.verified_printable_url 가 없습니다.`);
    svg_product_page.printable_url = svg_product_page.verified_printable_url;
  }
  if (svg_product_page.is_legacy_small_path === true) {
    const {
      is_OK,
      data: svg_url,
      reason,
    } = await SVGEditorUtilF.sanitizeSmallerAreaKeyringHole({
      svg_url: svg_product_page.cutting_line_url,
      svg_product_page_id: svg_product_page.id,
    });
    if (!is_OK) {
      throw new Error(`${svg_product_page.id} --- ${reason}`);
    }
    if (is_OK && svg_url) {
      svg_product_page.cutting_line_url = svg_url;
    }
  } else if (svg_product_page.is_legacy_small_path === false) {
    if (!svg_product_page.verified_cutting_line_url)
      throw new Error(`${svg_product_page.id} --- svg_product_page.verified_cutting_line_url 가 없습니다.`);
    svg_product_page.cutting_line_url = svg_product_page.verified_cutting_line_url;
  }
}

const ORIGNAL_PRODUCT_ID_TO_FILENAME_SUFFIX_MAP = {
  22232007: '_rol', // 넥슨요청 (250617) - 특정 키링 상품에 롤랜드 장비 사용에 대한 이름 표시를 파일명에 붙이기를 원함
};

function insertSuffixToFileName(file_name, suffix) {
  if (typeof file_name !== 'string' || typeof suffix !== 'string') return file_name;
  const lastDotIndex = file_name.lastIndexOf('.');
  if (lastDotIndex > 0 && lastDotIndex < file_name.length - 1) {
    // 확장자가 있음
    return file_name.slice(0, lastDotIndex) + suffix + file_name.slice(lastDotIndex);
  }
  // 확장자가 없음
  return file_name + suffix;
}

export const vectorDownload = async ({
  projection_id,
  up_id,
  quantity,
  product_id,
  original_product_id,
  task_id,
  up_c_s_id,
}) => {
  return go(
    $.get('/@api/bp_option/file_name_and_files', { product_id, projection_id, up_id, quantity }),
    each(verifyKeyringHook),
    flatMap(async ({ png_file_name, svg_file_name, printable_url, cutting_line_url }) => {
      const [printable, svg] = await Promise.all([
        go(axios.get(printable_url, { responseType: 'arraybuffer' }), sel('data')),
        go(axios.get(cutting_line_url, { responseType: 'arraybuffer' }), sel('data')),
      ]);

      const file_name_suffix = ORIGNAL_PRODUCT_ID_TO_FILENAME_SUFFIX_MAP[original_product_id] || '';
      return [
        {
          file_name: insertSuffixToFileName(png_file_name, file_name_suffix),
          canvas_blob: await go(printable, (buffer) => {
            const blob = new Blob([new Uint8Array(buffer)], { type: 'image/png' });
            return changeDpiBlob(blob, 300);
          }),
          task_id,
          up_c_s_id,
        },
        {
          file_name: insertSuffixToFileName(svg_file_name, file_name_suffix),
          canvas_blob: new Blob([new Uint8Array(svg)], { type: 'image/svg+xml' }),
          task_id,
          up_c_s_id,
        },
      ];
    }),
  );
};

export const getCuttingLineSvg = async ({ product_id }) => {
  const cutting_line_url = (await axios.get('/@api/svg_product/cutting_line_url', { params: { product_id } }))
    .data;
  if (cutting_line_url == null) return;

  return await getCuttingLineSvgFromUrl({ cutting_line_url });
};

export const getCuttingLineSvgFromUrl = async ({ cutting_line_url }) => {
  return (await axios.get(cutting_line_url)).data;
};

export const vectorDownload2 = async ({ projection_id, up_id, quantity, product_id }) => {
  return go(
    $.get('/@api/bp_option/file_name_and_files', { product_id, projection_id, up_id, quantity }),
    each(verifyKeyringHook),
    flatMap(async ({ id, png_file_name, svg_file_name, printable_url, cutting_line_url }) => {
      const [printable, svg] = await Promise.all([
        go(axios.get(printable_url, { responseType: 'arraybuffer' }), sel('data')),
        go(axios.get(cutting_line_url, { responseType: 'arraybuffer' }), sel('data')),
      ]);
      return [
        {
          file_name: png_file_name,
          blob: await go(printable, (buffer) => {
            const blob = new Blob([new Uint8Array(buffer)], { type: 'image/png' });
            return changeDpiBlob(blob, 300);
          }),
        },
        {
          file_name: svg_file_name,
          blob: new Blob([new Uint8Array(svg)], { type: 'image/svg+xml' }),
        },
      ];
    }),
  );
};
